<ng-container>
  @if (showGeneralInformation) {
    <div>
      <ng-container>
        <div>
          <div class="declaration-block my-4">
            <h2>Exemption Information</h2>
          </div>
        </div>
      </ng-container>
    </div>
  }

  <ng-container>

    @if (hasExemptions()) {
      <app-tab-panel [activeIndex]="getExemptions().length - 1">
        @for (exemptionReferenceData of getExemptions(); track exemptionReferenceData; let i = $index) {
          <app-tab-item [templateRef]="exemptionTabRef">
            <span class="tab-item">{{ getName(i).split(' ')[0] }}</span>
            <ng-template #exemptionTabRef>
              <div class="p-3 border border-top-0 rounded-bottom">
                @if (showExemption) {
                  <div>
                    {{
                      setSelectedExemptionIndex(i)
                    }}
                    <div>
                      @switch (exemptionReferenceData.exemptionType) {
                        @case ('Exemption General') {
                          <div>
                            <app-visit-exemptions-exemption-general [considering]="getConsidering(i)"
                                                                    [name]="getName(i)"
                                                                    [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-general>
                          </div>
                        }
                        @case ('Exemption Debunkering') {
                          <div>
                            <app-visit-exemptions-exemption-debunkering [considering]="getConsidering(i)"
                                                                        [name]="getName(i)"
                                                                        [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-debunkering>
                          </div>
                        }
                        @case ('Exemption ISPS') {
                          <div>
                            <app-visit-exemptions-exemption-isps [berthVisit]="berthVisit"
                                                                 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                 [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-isps>
                          </div>
                        }
                        @case ('Exemption Oude Maas') {
                          <div>
                            <app-visit-exemptions-exemption-oude-maas [berthVisit]="berthVisit"
                                                                      [considering]="getConsidering(i)"
                                                                      [name]="getName(i)"
                                                                      [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-oude-maas>
                          </div>
                        }
                        @case ('Exemption Tijpoort') {
                          <div>
                            <app-visit-exemptions-exemption-tijpoort [considering]="getConsidering(i)"
                                                                     [name]="getName(i)"
                                                                     [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-tijpoort>
                          </div>
                        }
                        @case ('Exemption 3.2') {
                          <div>
                            <app-visit-exemptions-exemption-3-2 [berthVisit]="berthVisit"
                                                                [considering]="getConsidering(i)"
                                                                [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-3-2>
                          </div>
                        }
                        @case ('Exemption 3.4') {
                          <div>
                            <app-visit-exemptions-exemption-3-4 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-3-4>
                          </div>
                        }
                        @case ('Exemption 3.5') {
                          <div>
                            <app-visit-exemptions-exemption-3-5 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-3-5>
                          </div>
                        }
                        @case ('Exemption 3.6') {
                          <div>
                            <app-visit-exemptions-exemption-3-6 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-3-6>
                          </div>
                        }
                        @case ('Exemption 3.11') {
                          <div>
                            <app-visit-exemptions-exemption-3-11 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                 [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-3-11>
                          </div>
                        }
                        @case ('Exemption 3.13') {
                          <div>
                            <app-visit-exemptions-exemption-3-13 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                 [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-3-13>
                          </div>
                        }
                        @case ('Exemption 4.1') {
                          <div>
                            <app-visit-exemptions-exemption-4-1 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-4-1>
                          </div>
                        }
                        @case ('Exemption 4.5') {
                          <div>
                            <app-visit-exemptions-exemption-4-5 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-4-5>
                          </div>
                        }
                        @case ('Exemption 4.6') {
                          <div>
                            <app-visit-exemptions-exemption-4-6 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-4-6>
                          </div>
                        }
                        @case ('Exemption 4.11') {
                          <div>
                            <app-visit-exemptions-exemption-4-11 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                 [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-4-11>
                          </div>
                        }
                        @case ('Exemption 4.11b') {
                          <div>
                            <app-visit-exemptions-exemption-4-11b [considering]="getConsidering(i)" [name]="getName(i)"
                                                                  [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-4-11b>
                          </div>
                        }
                        @case ('Exemption 4.13 (1)') {
                          <div>
                            <app-visit-exemptions-exemption-4-13-1 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                   [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-4-13-1>
                          </div>
                        }
                        @case ('Exemption 4.13 (2)') {
                          <div>
                            <app-visit-exemptions-exemption-4-13-2 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                   [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-4-13-2>
                          </div>
                        }
                        @case ('Exemption 5.2') {
                          <div>
                            <app-visit-exemptions-exemption-5-2 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-5-2>
                          </div>
                        }
                        @case ('Exemption 5.3') {
                          <div>
                            <app-visit-exemptions-exemption-5-3 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-5-3>
                          </div>
                        }
                        @case ('Exemption 5.4, 5.5, 5.6') {
                          <div>
                            <app-visit-exemptions-exemption-5-4 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-5-4>
                          </div>
                        }
                        @case ('Exemption 5.4, 5.6, 5.7') {
                          <div>
                            <app-visit-exemptions-exemption-5-4-2 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-5-4-2>
                          </div>
                        }
                        @case ('Exemption 6.3.1') {
                          <div>
                            <app-visit-exemptions-exemption-6-3-1 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                  [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-6-3-1>
                          </div>
                        }
                        @case ('Exemption 6.3.3, 6.3.4') {
                          <div>
                            <app-visit-exemptions-exemption-6-3-3 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                  [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-6-3-3>
                          </div>
                        }
                        @case ('Exemption 6.3.5') {
                          <div>
                            <app-visit-exemptions-exemption-6-3-5 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                  [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-6-3-5>
                          </div>
                        }
                        @case ('Exemption 6.4') {
                          <div>
                            <app-visit-exemptions-exemption-6-4 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-6-4>
                          </div>
                        }
                        @case ('Exemption 6.5') {
                          <div>
                            <app-visit-exemptions-exemption-6-5 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-6-5>
                          </div>
                        }
                        @case ('Exemption 7.1 lid 1') {
                          <div>
                            <app-visit-exemptions-exemption-7-1-1 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                  [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-7-1-1>
                          </div>
                        }
                        @case ('Exemption 7.1 lid 2') {
                          <div>
                            <app-visit-exemptions-exemption-7-1-2 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                  [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-7-1-2>
                          </div>
                        }
                        @case ('Exemption 8.1') {
                          <div>
                            <app-visit-exemptions-exemption-8-1 [considering]="getConsidering(i)" [name]="getName(i)"
                                                                [exemption]="getExemptionFor(exemptionReferenceData)"></app-visit-exemptions-exemption-8-1>
                          </div>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            </ng-template>
          </app-tab-item>
        }
      </app-tab-panel>
    }
  </ng-container>
</ng-container>
